import { AppState } from "../models";
import { useSelector } from "react-redux";

export default function useAppState(): AppState {
	return useSelector<AppState, AppState>((appState) => appState);
}
